<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/APY2Zc/tc-custom/9781460303955.jpg?1728851645607" alt="This image is the cover for the book Rancher's Dangerous Affair, Vengeance in Texas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rancher's Dangerous Affair, Vengeance in Texas
      </h1>
      <p class="bookDescription body article font2">
        <i>"You still push every one of my buttons."</i><br/><br/>Not long after Eliza Harvey-Reed got married, her husband  David's infidelity proved she married the wrong brother. But was Brandon Reed, her old high-school flame, the <i>right</i> one? Now Eliza's back in their hometown of Vengeance, Texas. And when she first lays eyes on Brandon, it's obvious the heat between  them is as all-consuming as ever.<br/><br/>Brandon Reed's still furious that Eliza married his brother. Even more frustrating is that he can't help being drawn to her like a moth to a flame. But when David is murdered, Eliza tops the suspect list. Now Brandon must help clear her name before the real killer destroys his second chance at true love.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Morey
      </h2>
      
      <p class="authorDescription body article">Two-time RITA nominee and Golden Quill winner, Jennifer Morey writes her happy endings in Denver, Colorado. Aside from writing great contemporary and page-turning romantic suspense, she has a geology degree and consults compliance with the International Traffic in Arms Regulations. She loves movies, her three dogs, and her honey--not necessarily in that order! You may contact her through her website, <a href="http://www.jennifermorey.co">www.jennifermorey.com</a></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5797d31e